import React, { SelectHTMLAttributes } from "react";

interface SelectTipoProps extends SelectHTMLAttributes<HTMLSelectElement> {
}

export const SelectTipo = ({ ...rest }: SelectTipoProps) => {
  return (
    <div className="my-2 flex h-8 w-full items-center justify-between gap-4">
      <p className="w-2/6 font-medium text-gray-700">Tipo: </p>
      <select className="h-full w-full bg-gray-200 px-1 " name="tipo_telefone" {...rest} >
        <option value="Fixo Residencial">Fixo Residencial</option>
        <option value="Fixo Comercial">Fixo Comercial</option>
        <option value="Fixo Referencia">Fixo Referencia</option>
        <option value="Fixo Trabalho Conjuge">Fixo Trabalho Conjuge</option>
        <option value="Movel Particular">Movel Particular</option>
        <option value="Movel Comercial">Movel Comercial</option>
        <option value="Movel Referencia">Movel Referencia</option>
        <option value="Movel Conjuge">Movel Conjuge</option>
        <option value="Outros">Outros</option>
      </select>
    </div>
  )
}